import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { LikertDataMobileService } from './likert-data-mobile.service';
import { LikertMockService } from './likert-data-mock.service';
import { LikertDataService } from './likert-data.service';
import { DataOrigin } from '../../model/DataOrigin';

@Injectable({
    providedIn: 'root'
})
export abstract class LikertFactoryService {

    private services = new Map<DataOrigin, LikertDataService>();

  constructor(private handlerService: HandlerService) {}

  public getService(origin: DataOrigin) {
    if (this.services.has(origin)) {
      return this.services.get(origin);
    } else {
      return this.constructService(origin);
    }
  }

  private constructService(origin: DataOrigin): LikertDataService {
    switch (origin) {
      case DataOrigin.Mobile:
        const serviceUserMobile = new LikertDataMobileService(this.handlerService);
        this.services.set(origin, serviceUserMobile);
        return serviceUserMobile;
      case DataOrigin.Mock:
        const serviceMock = new LikertMockService();
        this.services.set(origin, serviceMock);
        return serviceMock;
      default:
        const serviceDefault = new LikertMockService();
        this.services.set(origin, serviceDefault);
        return serviceDefault;
    }
  }

}

